import { render, staticRenderFns } from "./LibraryElementEditDialog.vue?vue&type=template&id=04dd7658"
import script from "./LibraryElementEditDialog.vue?vue&type=script&lang=js"
export * from "./LibraryElementEditDialog.vue?vue&type=script&lang=js"
import style0 from "./LibraryElementEditDialog.vue?vue&type=style&index=0&id=04dd7658&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports